import React, { useEffect, useState } from 'react';
import Loader from '../../component/loader/home_loading';
import HorizontalThumbnail from '../Thumbnail/horizontalThumbnail.jsx';
import VerticalThumbnail from '../Thumbnail/verticalThumbnail.jsx';
import ContinueWatchingThumbnail from '../Thumbnail/continueWatchingThumbnail';
import Thumbnail835X1080 from '../Thumbnail/thumbnail835X1080';
import Thumbnail1080X1850 from '../Thumbnail/thumbnail1080X1850';
import Thumbnail1080X1400 from '../Thumbnail/thumbnail1080X1400';
import Thumbnail1080X1080 from '../Thumbnail/thumbnail1080X1080';
import Thumbnail925X1920 from '../Thumbnail/thumbnail925X1920';
import Thumbnail1920X1080 from '../Thumbnail/thumbnail1920X1080'
import Thumbnail444X666 from '../Thumbnail/thumbnail444X666'
import DefaultThumbnail from '../Thumbnail/defaultThumbnail'
import TopPicker from '../Thumbnail/toppicksThumbnail';
const HomeData = (props) => {
  const [homeData, setHomeData] = useState([]);
  const [isLoading, setisLoading] = useState(true)

  useEffect(() => {
    setHomeData(props.data)
    setisLoading(false)
    
  }, [props.data]);
 
  const HomeData = homeData !== null && homeData !== undefined && homeData.length > 0 && homeData.map((result, key) => {
    if (result.search_tag.length > 0) {
      
      return(
        <>
         {
          result.image_type !== null && result.image_type !== undefined && result.image_type === 'title_text_1080_840' ? <TopPicker  key={key} 
          Itmdata={result} 
          route_name={props.menuName}
           /> : ''
        }
        {
          result.image_type !== null && result.image_type !== undefined && result.image_type === 'size_1080_835' ? <Thumbnail835X1080  key={key} 
          Itmdata={result} 
          route_name={props.menuName}
           /> : ''
        }
        
        {
         result.image_type !== null && result.image_type !== undefined && result.image_type === 'size_1850_1080' ?  <Thumbnail1080X1850 key={key}
        Itmdata={result} 
        route_name={props.menuName} 
        /> : ''
        }
        {
         result.image_type !== null && result.image_type !== undefined && result.image_type === 'size_1080_1080' ?  <Thumbnail1080X1080 key={key} 
         Itmdata={result} 
         route_name={props.menuName}
          /> : ''
        }
        {
         result.image_type !== null && result.image_type !== undefined && result.image_type === 'size_1400_1080' ?  <Thumbnail1080X1400 key={key}
         Itmdata={result} 
         route_name={props.menuName} 
         /> : ''
        }
        {
         result.image_type !== null && result.image_type !== undefined && result.image_type === 'size_925_1920' ?  <Thumbnail925X1920 key={key} 
         Itmdata={result} 
         route_name={props.menuName} 
         /> : ''
        }
         {
         result.image_type !== null && result.image_type !== undefined && result.image_type === 'size_920_1080' ?  <Thumbnail1920X1080 key={key} 
         Itmdata={result} 
         route_name={props.menuName} 
         /> : ''
        }
        {
           result.image_type !== null && result.image_type !== undefined && result.image_type === '' ? <DefaultThumbnail key={key} 
           Itmdata={result} 
           route_name={props.menuName}  />  : ''
        }
         {/* {
           result.image_type !== null && result.image_type !== undefined && result.image_type === 'size_1080_1920' ? <DefaultThumbnail key={key} 
           Itmdata={result} 
           route_name={props.menuName}  />  : ''
        } */}
        {
         result.image_type !== null && result.image_type !== undefined && result.image_type === 'size_1080_1920' ?  <Thumbnail1920X1080 key={key} 
         Itmdata={result} 
         route_name={props.menuName} 
         /> : ''
        }
        {
         result.image_type !== null && result.image_type !== undefined && result.image_type === 'size_666_444' ?  <Thumbnail444X666 key={key} 
         Itmdata={result} 
         route_name={props.menuName} 
         /> : ''
        }
        </>
      )
    }
  })

  if (!isLoading) {
    return (
      <>
      {
       props.continueWatchingData !== null && props.continueWatchingData !== undefined  && props.continueWatchingData.length > 0 ? <ContinueWatchingThumbnail data={props.continueWatchingData}  />  : ''
      }
        {/* <TopPicker /> */}
        {/* <Thumbnail444X666  /> */}
        {HomeData}
      </>
    );
  } 
  else {
    return (<Loader />)
  }

}
export default HomeData;